import { render, staticRenderFns } from "./PayMore.vue?vue&type=template&id=1040aeae&scoped=true&"
import script from "./PayMore.vue?vue&type=script&lang=js&"
export * from "./PayMore.vue?vue&type=script&lang=js&"
import style0 from "./PayMore.vue?vue&type=style&index=0&id=1040aeae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040aeae",
  null
  
)

export default component.exports